import { Component, EventEmitter, Input, OnChanges, Output, SimpleChanges } from '@angular/core';

@Component({
  selector: 'app-confirm-modal',
  templateUrl: './confirm-modal.component.html',
  styleUrls: ['./confirm-modal.component.scss']
})
export class ConfirmModalComponent implements OnChanges {

  @Input()
  public openModal: boolean;
  @Input()
  public title: string = 'Template Priority';
  @Input()
  public message: string;
  @Input()
  public requirePassword: boolean;
  @Output()
  public outcome = new EventEmitter<any>();

  public customHeader = true;
  public passwordValue: string = '';
  public idTitle: string = this.title.split(" ").join('-').toLowerCase();
  public type: string = 'password';
  public inputName: string = 'visibility';
  public correctPass: boolean = false;
  public passwordResetToDefault: boolean = false;

  ngOnChanges(changes: SimpleChanges): void {
    if (changes?.openModal?.currentValue) {
      this.passwordResetToDefault = false;
      setTimeout(() => {
        this.passwordResetToDefault = true;
      }, 100);
    }
  }

  handleOpenClose = (event: any) => {
    this.passwordValue = '';
    this.outcome.emit({status: false, value: 'cancel'});
  }
  applyModal = () => {
    this.passwordValue = '';
    this.outcome.emit({status: true, value: 'apply'});
  }
  handleChange = (value) => {
    this.passwordValue = value;
    if(this.passwordValue === 'ennel1') {
      this.correctPass = true;
    }else{
      this.correctPass = false;
    }
  }
  inputType = () => {
    this.inputName === "visibility_off"
      ? ((this.type = "password"), (this.inputName = "visibility"))
      :  ((this.type = "text"), (this.inputName = "visibility_off"));
  }
}
